import { Button, Input, Select } from "antd";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { backendEndpoint, fetchBackendApi } from "./../../reducers/fetch";

export default function NewFlow() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [newFlow, setNewFlow] = useState({
    brand: "",
    app: "",
    name: "",
    version: "",
  });
  const navigate = useNavigate();

  const handleChange = (event) => {
    setNewFlow({ ...newFlow, [event.target.name]: event.target.value });
  };

  const handleCreate = () => {
    setLoading(true);
    setError(false);
    if (!newFlow.brand || !newFlow.app || !newFlow.name || !newFlow.version) {
      setError(true);
      setLoading(false);
      return;
    }
    fetchBackendApi(
      "post",
      backendEndpoint + "flows",
      {
        brand: newFlow.brand,
        app: newFlow.app,
      },
      {
        name: newFlow.name,
        version: newFlow.version,
        nodes: [],
        edges: [],
        viewport: {},
      }
    )
      .then(() => {
        navigate(
          `/${newFlow.app}/${newFlow.brand}/${newFlow.name}/${newFlow.version}`
        );
      })
      .catch((e) => {
        setError(true);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  return (
    <div
      style={{
        width: "70%",
        maxWidth: "800px",
        padding: "30px 0px",
        margin: "0 auto",
      }}
    >
      <h1>New Flow</h1>
      <Input
        placeholder="Brand"
        size="large"
        value={newFlow.brand}
        name="brand"
        onChange={handleChange}
        autoComplete="off"
      />
      <Select
        style={{ width: "100%", marginTop: "15px" }}
        placeholder="App"
        options={[
          { value: "allo-brain", label: "allo-brain" },
          { value: "web-app", label: "web-app" },
          { value: "call-bot", label: "call-bot" },
        ]}
        size="large"
        onChange={(value) => setNewFlow({ ...newFlow, app: value })}
      />
      <Input
        placeholder="Flow Name"
        style={{ marginTop: "15px" }}
        size="large"
        name="name"
        onChange={handleChange}
        autoComplete="off"
      />
      <Input
        placeholder="Version"
        style={{ marginTop: "15px" }}
        size="large"
        name="version"
        onChange={handleChange}
        autoComplete="off"
      />
      <Button
        size="large"
        style={{ marginTop: "15px" }}
        type="primary"
        onClick={handleCreate}
        loading={loading}
      >
        Create
      </Button>
      {error && (
        <p style={{ color: "red", marginTop: "10px" }}>
          An error has occurred.
        </p>
      )}
    </div>
  );
}
